import React from 'react';

const Careers = () => {
  return (
    <h1>Careers</h1>
  );
};

export default Careers;